import * as THREE from 'three';
import rVert from "../glsl/rVert.vert";
import rFrag from "../glsl/rFrag.frag";
import r1vert from "../glsl/r1.vert";
import r1frag from "../glsl/r1.frag";
import snoise from "../glsl/simplexNoise.frag";

import rdPlaneVert2 from "../glsl/rdPlane2.vert";
import rdPlaneFrag2 from "../glsl/rdPlane2.frag";

import { Matrix4, Texture } from 'three';
import { CameraUtil } from '../data/CameraUtil';
import { Params } from '../data/Params';
import gsap from 'gsap';

export class ReverseObj extends THREE.Mesh{

    //geometry:
    material:THREE.ShaderMaterial;
    envMap:Texture;
    rad:number = 0;
    offset:number = 0;

    constructor(){

          /*      
        const loaderEnv = new THREE.CubeTextureLoader();
        loaderEnv.setPath( './topimg/' );
        let envMap = loaderEnv.load( [ 'px.jpeg', 'nx.jpeg','py.jpeg','ny.jpeg', 'pz.jpeg', 'nz.jpeg' ] );
        envMap.mapping = THREE.CubeReflectionMapping;
        */    

        /*
        let loader2 = new THREE.TextureLoader();
        let tex2 = loader2.load("./topimg/w2.png");

        tex2.mapping = THREE.EquirectangularReflectionMapping;
        tex2.encoding = THREE.sRGBEncoding;*/

        //tex2.needsUpdate=true;



        //let loader = new THREE.TextureLoader();
        //let tex = loader.load("./topimg/basket.png");
        
        //let loader3 = new THREE.TextureLoader();
        //let tex3 = loader3.load("./topimg/color3.png")

        let rgb = new THREE.Vector3(Params.random(),Params.random(),Params.random());
        

        let mat = new THREE.ShaderMaterial({
                
            vertexShader: r1vert,   
            fragmentShader: snoise + r1frag,
            
            uniforms: THREE.UniformsUtils.merge(
                [
                    THREE.ShaderLib[ 'phong' ].uniforms,        
                    {
                        tex1: { value: null },
                        tex2: { value: null },
                        map: { value: null },
                        receiveShadow:{value:true},
                        //envMap2: {value: envMap},
                        //wireframe:{value: true},
                        colorId:{value:Params.colorId/Params.colorMax},
                        color1:{value: rgb },
                        color2:{value: rgb },
                        projMat:{value: new THREE.Matrix4() },
                        counter:{value: 0},
                        size: { value: new THREE.Vector2(0,0) }
                    }
                ]
            )
        });
        
        //mat["envMap"] = envMap;
        //mat["combine"] = THREE.MultiplyOperation;
        //mat.uniforms.envMap.value = envMap;
        mat.uniforms.refractionRatio.value = 1.0;
        mat.uniforms.diffuse.value = new THREE.Color('#ffaaaa');
        

        let WIDTH:number = 128;
        let BOUNDS:number = 512;

        //mat.defines.USE_ENVMAP = 1;
        mat.defines.USE_ENVMAP="";
        mat.defines.ENVMAP_TYPE_CUBE="";
        //mat.defines.ENVMAP_MODE_REFLECTION = "";
        //mat.defines.ENVMAP_TYPE_CUBE_UV = ''

        /*
            material.defines.USE_ENVMAP = ''
            material.defines.ENVMAP_MODE_REFLECTION = ''
            material.defines.ENVMAP_TYPE_CUBE_UV = ''
            material.defines.ENVMAP_BLENDING_MULTIPLY = ''
            material.defines.TEXTURE_LOD_EXT = ''
            material.defines.USE_UV = ''
        */


        //mat.defines.WIDTH = WIDTH.toFixed( 1 );
        //mat.defines.BOUNDS = BOUNDS.toFixed( 1 );


        mat.defines.USE_SHADOWMAP = ''

        mat.side = THREE.DoubleSide;
        mat.lights = true;
        //mat.uniforms.receiveShadow.value=true;
        
        

        super(
            
            
            //new THREE.BoxGeometry(
            //    Math.random(),
            //    Math.random(),
            //    Math.random(),
            //    1,1,1
            //),
            //Params.wire.geometry,
            new THREE.SphereGeometry(0.2, 20, 20),
            //new THREE.TorusKnotGeometry(0.5,0.25,70,20,2,3),
            mat
        );
        //let ss = 0.001;
        //this.scale.set(ss,ss,ss)
        
        //this.material.uniforms.envMap2.value = tex2;

        this.rotation.x = Math.PI*Params.random();
        this.rotation.y = Math.PI*Params.random();
        this.rotation.z = Math.PI*Params.random();

        this.receiveShadow=true;

    }


    tween(duration:number,p:THREE.Vector3, ss:number){

        gsap.to(this.scale,{
            x:ss,y:ss,z:ss,
            duration:duration,
            ease:"Power2.easeInOut"
        });
        
        gsap.to(this.position,{
            x:p.x,
            y:p.y,
            z:p.z,
            duration:duration,
            //delay: 0.1*idx/(xx*yy),
            ease:"Power2.easeInOut",
            delay: Math.random()*0.2*duration
          });

    }


    update(){
/*        
        this.position.x = 1.0 * Math.sin( this.rad );
        //this.position.z = 0.3 * Math.cos( this.rad + this.offset );
        this.position.y = 0.6 * Math.sin( this.rad * 2 );
        this.rad+=0.02;
        this.offset+=0.04;
*/
        //this.rotation.x+=0.001;
        //this.rotation.z+=0.001;
        
        //this.rotation.y+=0.004;

        //this.material.uniforms.resolution.value.x = window.innerWidth;
        //this.material.uniforms.resolution.value.y = window.innerHeight;
        this.material.uniforms.counter.value += 0.1;
        this.material.uniforms.projMat.value = CameraUtil.Instance.GetProjectionMatrix();

    }


    


}